export default __webpack_public_path__ + "static/media/Lora-Medium.2d39b3fb.ttf";